import { formatQuery } from '@/utils';

import http from './http';
import serviceHelper from './serviceHelper';

export const getChildrenPersonalSubscriberList = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/children/personal-subscriber${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getChildrenPersonalSubscriberSummary = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/children/personal-subscriber/summary${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getChildrenSchoolSubscriberList = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(`/admin/school/children${queryString ? `?${queryString}` : ''}`),
    false
  );
};

export const getChildrenSchoolSubscriberSummary = async (
  query?: Record<string, unknown>
) => {
  const queryString = query ? formatQuery(query) : '';
  return serviceHelper(
    http.get(
      `/admin/school/children/summary${queryString ? `?${queryString}` : ''}`
    ),
    false
  );
};

export const getStudentDetails = async (id: string) => {
  return serviceHelper(
    http.get(`/admin/child/personal-subscriber/${id}`),
    false
  );
};

export const updateChildLevel = async (payload: {
  children_id: string;
  stage: string;
}) => {
  return serviceHelper(http.patch('/admin/children', payload), true);
};

export const getChildDevices = async (id: string) => {
  return serviceHelper(http.get(`/admin/child/${id}/devices`), false);
};

export const deleteChildDevice = async (id: string) => {
  return serviceHelper(http.delete(`/admin/child/device/${id}`), true);
};
